import { useState, useEffect, useCallback } from 'react';

const heroImages = [
  { src: '/images/hero-4.jpg', alt: 'Motif Farms - Farm facility' },
];

const SLIDE_INTERVAL = 5000; // 5 seconds

function Hero() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % heroImages.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, SLIDE_INTERVAL);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      {/* Background Image Carousel */}
      {heroImages.map((image, index) => (
        <div
          key={index}
          className="absolute inset-0 z-0 transition-opacity duration-1000 ease-in-out"
          style={{ opacity: index === currentIndex ? 1 : 0 }}
        >
          <img
            className="w-full h-full object-cover"
            src={image.src}
            alt={image.alt}
          />
        </div>
      ))}

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70 z-10"></div>

      {/* Hero Content */}
      <div className="relative z-20 text-center px-6 max-w-[900px]">
        <h1
          className="text-white text-5xl md:text-7xl font-black leading-[1.1] mb-6"
          style={{ fontFamily: "'Inter', sans-serif", textShadow: '2px 2px 8px rgba(0,0,0,0.7), 0 0 40px rgba(0,0,0,0.4)' }}
        >
          Turkey Farm & Hatchery
        </h1>
        <p
          className="text-white text-lg md:text-2xl font-medium mb-10 tracking-wide"
          style={{ textShadow: '1px 1px 6px rgba(0,0,0,0.6)' }}
        >
          Quality Turkeys. Raised with Care.
        </p>
        <p
          className="text-white text-md mb-10 font-medium"
          style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.5)' }}
        >
          Medie–Kotoku, Accra, Ghana
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            className="w-full sm:w-auto bg-primary hover:bg-primary-light text-white px-10 py-4 rounded-lg text-lg font-bold transition-all shadow-lg transform hover:-translate-y-1"
            href="#order"
          >
            Order Now
          </a>
          <a
            className="w-full sm:w-auto bg-white/20 hover:bg-white/30 backdrop-blur-md text-white border border-white/50 px-10 py-4 rounded-lg text-lg font-bold transition-all"
            href="#products"
          >
            View Products
          </a>
        </div>

        {/* Slide Indicators */}
        <div className="flex items-center justify-center gap-2 mt-8">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === currentIndex
                ? 'bg-white w-8'
                : 'bg-white/50 hover:bg-white/80'
                }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Hero;